














import { Component, Vue } from "vue-property-decorator";

@Component
export default class UserErrorModal extends Vue {
    // local state
    errorMessage: string = "";

    // methods
    open(error: string) {
        this.errorMessage = error;
        this.$bvModal.show("modal-errorUser");
    }

    confirm() {
        this.$bvModal.hide("modal-errorUser");
        this.errorMessage = "";
    }
}
